import { GridColDef } from '@material-ui/data-grid'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import ArrowDropUp from '@mui/icons-material/ArrowDropUp'
import { CFDIS_ZIP_UPLOAD_CATEGORIES } from 'lib/enums/invoices.enums'
import {
  cfdisZIPUploadCategoriesTitleIconMap,
  cfdisZIPUploadCategoriesTitleMap,
} from 'lib/utils/Invoices/invoices.utils'
import SydExpandableInformationDetails from 'components/Shared/SydExpandableInformationDetails/SydExpandableInformationDetails'
import SydSkeletonLoading from 'components/Shared/SydSkeletonLoading/SydSkeletonLoading'
import SydTable from 'components/Shared/SydTable/SydTable'
import useCFDIsZipUploadDetailsContainer from './useCFDIsZipUploadDetailsContainer'
import './styles.scss'

const CFDIsZipUploadDetailsContainer = () => {
  const {
    hasAtLeastOneCategoryData,
    cfdisZIPUploadCategoriesDataMap,
    cfdisZIPUploadInfo,
    cfdisZIPUploadInfoLoading,
    isCFDIsZIPUploadInfoError,
    uploadDetailsError,
    uploadDetailsLoading,
  } = useCFDIsZipUploadDetailsContainer()

  const { zipFileName, zipFileExtension, totalFiles } =
    cfdisZIPUploadInfo ?? {}

  const cfdisZIPUploadDetailsTableColumn: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Nombre del archivo',
      flex: 1,
      sortable: false,
      valueFormatter: ({ row: { name, extension } }) => `${name}.${extension}`,
    },
  ]

  return (
    <div className="cfdis-zip-upload-details-container">
      {cfdisZIPUploadInfoLoading && !isCFDIsZIPUploadInfoError && (
        <SydSkeletonLoading height="32px" />
      )}

      {!cfdisZIPUploadInfoLoading && cfdisZIPUploadInfo && (
        <h1>
          {`${zipFileName}.${zipFileExtension}`}{' '}
          <span>- {totalFiles} archivos</span>
        </h1>
      )}

      {uploadDetailsLoading && !uploadDetailsError && (
        <SydSkeletonLoading height="calc(100vh - 383px)" marginTop="16px" />
      )}

      {!uploadDetailsLoading && hasAtLeastOneCategoryData && (
        <article className="upload-details">
          {Object.values(CFDIS_ZIP_UPLOAD_CATEGORIES).map(category => {
            const categoryData =
              cfdisZIPUploadCategoriesDataMap[category]

            const totalCategoryRows = categoryData?.rowCount

            return (
              categoryData?.rows &&
              !!totalCategoryRows &&
              totalCategoryRows > 0 && (
                <div
                  key={`zip-upload-details-${category}`}
                  className="upload-detail">
                  <SydExpandableInformationDetails
                    className="cfdis-zip-upload-category"
                    title={`${totalCategoryRows} archivo${
                      totalCategoryRows > 1 ? 's' : ''
                    } ${cfdisZIPUploadCategoriesTitleMap[category]}`}
                    titleIcon={
                      cfdisZIPUploadCategoriesTitleIconMap[category]
                    }
                    openToggleElement={<ArrowDropUp />}
                    closeToggleElement={<ArrowDropDown />}
                    content={
                      <SydTable
                        columns={cfdisZIPUploadDetailsTableColumn}
                        {...categoryData}
                        rowHeight={32}
                        checkboxSelection={false}
                        noBorder
                      />
                    }
                  />
                  <hr />
                </div>
              )
            )
          })}
        </article>
      )}
    </div>
  )
}

export default CFDIsZipUploadDetailsContainer
